import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { PaymentTransactionsViewModel } from '@usf/payment-types';

@Component({
  selector: 'app-transactions-failed-details',
  templateUrl: './transactions-failed-details.component.html',
  styleUrls: ['./transactions-failed-details.component.scss'],
})
export class TransactionsFailedDetailsComponent implements OnInit {
  @Input() transactionsFailed: PaymentTransactionsViewModel[] = [];
  areDetailsShowing = true;
  errorTexts: Record<string, string>;

  constructor(
    readonly platformService: PlatformService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.errorTexts = this.translateService.instant(
      'i18n.payments.paymentConfirmation.failedTransactionErrors',
    );
  }

  accordionGroupChange = ev => {
    this.areDetailsShowing = !!ev.detail.value;
  };
}
